/* eslint-disable no-console */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-confusing-void-expression */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import React, { useEffect, useRef, useState } from 'react';
import { useInView } from 'react-intersection-observer';

interface VideoBackgroundProps {
  url: string;
  posterUrl: string;
}

const VideoBackground: React.FC<VideoBackgroundProps> = ({ url, posterUrl }) => {
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (inView && !isVideoLoaded && videoRef.current) {
      const videoElement = videoRef.current;
      
      const onCanPlayThrough = () => {
        setIsVideoLoaded(true);
        videoElement.play().catch(console.error);
      };

      videoElement.addEventListener('canplaythrough', onCanPlayThrough);
      videoElement.load();

      return () => {
        videoElement.removeEventListener('canplaythrough', onCanPlayThrough);
      };
    }
  }, [inView, isVideoLoaded, url]);

  return (
    <div ref={ref} className="absolute inset-0 -z-10 bg-gray-200">
      {inView && (
        <>
          <img
            src={posterUrl}
            alt=""
            className="h-full w-full object-cover"
            style={{ display: isVideoLoaded ? 'none' : 'block' }}
          />
          <video
            ref={videoRef}
            className="h-full w-full object-cover"
            muted
            loop
            playsInline
            preload="auto"
            poster={posterUrl}
            style={{ display: isVideoLoaded ? 'block' : 'none' }}
          >
            <source src={url} type="video/mp4" />
          </video>
        </>
      )}
    </div>
  );
};

export default VideoBackground;
